export const EVENT_ACTIONS = {
  REGISTER: 'register',
  SEND_EVENT: 'sendEvent',
  REFRESH: 'refresh',
} as const;

export type EventActions = (typeof EVENT_ACTIONS)[keyof typeof EVENT_ACTIONS];

export type EventPayload = Record<string, any>;
